import React, { useEffect, useState } from 'react';
import { FaBuilding, FaDashcube, FaIcons, FaIdCardAlt, FaPowerOff, FaRegBuilding, FaSignInAlt, FaSignOutAlt, FaUnlockAlt } from 'react-icons/fa';
import { useThemeContext } from '../../../contexts/Theme-Context';
import { useAuthContext } from '../../../contexts/Auth-Context';
import { useSymbolContext } from '../../../contexts/Symbol-Context';
import { useMetricsContext } from '../../../contexts/Metrics-Context';
//import LoginWrapper from '../../utils/wrappers/LoginWrapper'
import './UserSettings.scss';
import { useNavigate } from 'react-router-dom';

import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';
import NotificationsDropdown from "../notifications/NotificationDropdown.jsx"
import { API_ENDPOINT_SAVE_LOGIN_TOKEN } from '../../../data/Endpoints-API.js';
import APIMiddleware from '../../../data/api/Api-Middleware.js';
import { toast } from 'react-toastify';
import getBackendUrl from '../../utils/RedirectUrl.js';
import { getChallengePhaseLabel } from '../../../utils/tradingLockMessage.ts';
import { localizeChallengePhaseLabel } from '../../../i18n/apiDisplayLabels';
import { useTranslation } from 'react-i18next';

const UserSettings = () => {
  const { t } = useTranslation();
  //CONTEXT
  const { theme, profileImage, setProfileImage } = useThemeContext();
  const { user, logout, login, isLoggingOut , setLogoutModal, setLoginPortalModal, platFromData } = useAuthContext();
  // const { mkRipple } = useSymbolContext();
  const { metrics } = useMetricsContext();
  const navigate = useNavigate();

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [mobileMode, setMobileMode] = useState(false);

  // const handleThemeChange = (themeKey) => {
  //   setTheme(themeKey);
  // };

  useEffect(() => {
    const checkMobileMode = () => {
      const isMobile = window.innerWidth <= 960;
      setMobileMode(isMobile);
    };

    // Initial check
    checkMobileMode();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobileMode);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('resize', checkMobileMode);
    };
  }, []);

  const loginToPortal = async () => {
    try {
      if (user && user.userId != undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_SAVE_LOGIN_TOKEN(user.userId)
        );
        if (response.data[0].UserLoginToken){
          window.open(`${getBackendUrl()}/auto_login?token=${response.data[0].UserLoginToken}`, '_blank');
        }
      }
    } catch (error) {
        toast.error(t('toasts.genericError'), {
          position: "top-right",
        });

      console.error(`Error getting user`, error);
    }
  };

  const handleLoginClick = () => {
    //if user already logged in then don't need to sho login page/modal
    if (user && user.userId != undefined) {
      login(user.userId, user.userName, user.balance);
    } else {
      setShowLoginModal(true);
    }
  };
  const clearAllThenLogout = async () => {
    await logout();
    // navigate('/');
  };

  const changeProfileImage = (e) => {
    setProfileImage(window.URL.createObjectURL(e.target.files[0]));
    window.URL.revokeObjectURL(e.target.files[0]);
  };

  const challengeInfo = platFromData?.[5]?.challengeInfo;

  const challengePhaseLabel = localizeChallengePhaseLabel(
    getChallengePhaseLabel(challengeInfo),
    t,
  );
  const challengeBadgeLabel = challengePhaseLabel
    ? `${challengePhaseLabel} ${t('userSettings.challenge')}`
    : t('userSettings.challenge');

  // An ended challenge keeps its badge — the phase name plus how it finished.
  const challengeStatusLabel = {
    passed: t('userSettings.passed'),
    failed: t('userSettings.failed'),
    completed: t('userSettings.completed'),
  }[challengeInfo?.status] || '';
  const challengeStatusColors = challengeInfo?.status === 'failed'
    ? { background: 'rgba(239, 68, 68, 0.15)', color: '#f87171', border: '1px solid rgba(239, 68, 68, 0.3)' }
    : { background: 'rgba(16, 185, 129, 0.15)', color: '#34d399', border: '1px solid rgba(16, 185, 129, 0.3)' };

  return (
    <>
      <div className="user-container">
        <div className="user-data-nd-settings" style={{ minWidth: 0, flex: '1 1 auto' }}>
          <div className="user-profile-picture">
            <input
              type="file"
              hidden
              id="imgSetter"
              onChange={(e) => changeProfileImage(e)}
              accept="image/.png,.jpeg,.jpeg,.webp,.heic,.bmp,.ico,.png"
            />
            <label htmlFor="imgSetter">
              <img src={profileImage} alt="profile picture" />
            </label>
          </div>
          <div className="settings-nd-name" style={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
            <h2 id="textBoldColor">{user?.userName || ''}</h2>
            <h2
              id="textBoldColor"
              style={{
                margin: 0,
                minWidth: 0,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              data-tooltip={user?.userAccountId || undefined}
            >
              {user?.userAccountId || ''}
            </h2>
            {(challengeInfo?.isChallenge) && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '3px',
                  marginTop: '4px',
                  minWidth: 0,
                  maxWidth: '100%',
                }}
              >
                <span style={{
                  background: challengeInfo.is_funded ? 'rgba(16, 185, 129, 0.15)' : 'rgba(245, 158, 11, 0.15)',
                  color: challengeInfo.is_funded ? '#34d399' : '#fbbf24',
                  border: challengeInfo.is_funded ? '1px solid rgba(16, 185, 129, 0.3)' : '1px solid rgba(245, 158, 11, 0.3)',
                  padding: '0px 4px',
                  borderRadius: '3px',
                  fontSize: '9px',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>{challengeBadgeLabel}</span>
                {challengeStatusLabel && (
                  <span style={{
                    ...challengeStatusColors,
                    padding: '0px 4px',
                    borderRadius: '3px',
                    fontSize: '9px',
                    fontWeight: '600',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                  }}>{challengeStatusLabel}</span>
                )}
              </div>
            )}
          </div>
        </div>
        {
          <div className="user-info-container" style={{ flexShrink: 0 }}>
              {mobileMode && <NotificationsDropdown />}
              <button
                className="login-button"
                disabled={isLoggingOut || localStorage.getItem('accountType') =="0" || platFromData?.[5]?.riskLocked || platFromData?.[5]?.accessRight == 3}
                onClick={() => {
                  setLoginPortalModal(true)
                }}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  isolation: 'isolate',
                  // backgroundColor: "#c5c5c5", 
                  color: "rgb(45, 45, 45)"
                }}
                data-tooltip={t('userSettings.loginToPortal')}
              >
                <Ripple />
                {/* Log into portal  */}
              <FaSignInAlt />
              </button>
              <button
                className="login-button"
                disabled={isLoggingOut}
                onClick={() => 
                  setLogoutModal(true)
                }
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  isolation: 'isolate',
                }}
                data-tooltip={t('userSettings.logOut')}
              >
                <Ripple />
                <FaPowerOff />
              </button>
          </div>
        }
      </div>
      {/* <hr className="horizontal-rule-1" /> */}

      <div className='balance-container'>
      <div className="user-balance global-platfrom" style={{display:'flex', justifyContent:'space-between'}}>
      <p>
          {t('userSettings.equity')}
          <span className='fw-bold'>
            {metrics?.userCurrencySymbol
              ? `${metrics.userCurrencySymbol} ${(Number(metrics.equity) || 0).toFixed(2)}`
              : '---'}
          </span>
        </p>
        <div>
       </div>
      </div>
      <div className="user-balance global-platfrom mobile-show">
        <p>
          {t('userSettings.balance')}
          <span className='fw-bold'>
            {metrics?.userCurrencySymbol
              ? `${metrics.userCurrencySymbol} ${(Number(metrics.balance) || 0).toFixed(2)}`
              : '---'}
          </span>
        </p>
      </div>
      </div>
      {/* <hr className="horizontal-rule-2" /> */}
    </>
  );
};

export default UserSettings;